"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M20 2H4a2 2 0 00-2 2v16a2 2 0 002 2h16a2 2 0 002-2V4a2 2 0 00-2-2z" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.656 13.9l6.95-6.95 1.414 1.414-7.657 7.657H9.95l-3.657-3.657 1.415-1.414 2.95 2.95z", fill: "currentColor", stroke: "transparent" })), "CheckboxChecked");
//# sourceMappingURL=CheckboxChecked.js.map